<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
import {mapGetters} from "vuex";

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (!localStorage.getItem('token')) {
          this.$router.push({path: '/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    reloadPage() {
      // 导航到指定页面
      this.$router.go(-1)
        // 强制刷新页面
      this.$nextTick(() => {
        setTimeout(() => {
          window.location.reload();
        }, 100);
      })
    }
  },
  created() {
    this.getBaseInfo();
  },
  watch: {
    activeLang(newval) {
      console.log("=>(App.vue:51) activeLang", newval);
      this.reloadPage();
    }
  }
}
</script>

<style>
body .van-toast {
  font-size: 30px;
  padding: 14px;
  line-height: 50px;
  width: fit-content !important;
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*, :after, :before {
  box-sizing: border-box;
}
.van-pull-refresh {
  min-height: 100%;
}
</style>
